import React from 'react';
import DatePicker from './closure-date-picker';
import Reason from './Reason';

const START_DATE_ID = 'start_date';
const END_DATE_ID = 'end_date';

type Props = {
  rowLabel: string;
  idPrefix: string;
  startDate: string | null;
  setStartDate: (date: string) => void;
  endDate: string | null;
  setEndDate: (date: string) => void;
  reason: string;
  setReason: (reason: string) => void;
};

const TemporaryClosure = (props: Props) => {
  const [focused, setFocused] = React.useState(null);

  const setStartDate = (v) => {
    props.setStartDate(v);
    setFocused(END_DATE_ID);
  };

  const setEndDate = (v) => {
    props.setEndDate(v);
    setFocused(null);
  };

  return (
    <div className="listing-status__temporary-closures__single-closure__dates">
      <DatePicker
        id={START_DATE_ID}
        inputId={`${props.idPrefix}-${START_DATE_ID}`}
        ariaLabel={`From date for ${props.rowLabel}`}
        key={'closure-' + START_DATE_ID}
        date={props.startDate}
        focused={focused === START_DATE_ID}
        handleChange={(p, v) => setStartDate(v)}
        onFocusChange={({ focused }) =>
          setFocused(focused ? START_DATE_ID : null)}
      />
      <DatePicker
        id={END_DATE_ID}
        inputId={`${props.idPrefix}-${END_DATE_ID}`}
        ariaLabel={`Through date for ${props.rowLabel}`}
        key={'closure-' + END_DATE_ID}
        indefinitelyPreset
        minimum={props.startDate}
        date={props.endDate}
        focused={focused === END_DATE_ID}
        handleChange={(p, v) => setEndDate(v)}
        onFocusChange={({ focused }) =>
          setFocused(focused ? END_DATE_ID : null)}
      />
      <Reason
        label={`Reason for ${props.rowLabel}`}
        reason={props.reason}
        handleChange={(p, v) => props.setReason(v)}
      />
    </div>
  );
};

export default TemporaryClosure;
